

import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { CourseListResponse, getCourses } from "../../../../api/courses";

interface UseLiveTeachingListParams {
  initialPage?: number;
  initialLimit?: number;
  isAdmin?: boolean;
}

export const useLiveTeachingList = ({
  initialPage = 1,
  initialLimit = 10,
  isAdmin = true,
}: UseLiveTeachingListParams) => {
  const [page, setPage] = useState(initialPage);
  const [limit] = useState(initialLimit);

  const responseQuery = useQuery<CourseListResponse>({
    queryKey: ["admin-live-teaching", { page, limit }],
    queryFn: () => getCourses({ page, limit, type: 'Live_Teaching' }, isAdmin),
  });

  const onPaginationChange = (pagination: { current: number; pageSize: number }) => {
    setPage(pagination.current);
  };

  return {
    ...responseQuery,
    page,
    limit,
    onPaginationChange,
  };
};